import ResourceApi from '../ResourceApi';

const SalaryResource = {
  get: async (params = {}) => (await ResourceApi.get('/resource/salary', params)).data,
  review: async (params = {}) => (await ResourceApi.get('/resource/salary/reviews', params)).data,
  update: async (id, params = {}) => (await ResourceApi.put(`/resource/salary/${id}`, params)).data,
  create: async (params = {}) => (await ResourceApi.post('/resource/salary', params)).data,
};

export default SalaryResource;
